import React from "react";
import styled from "styled-components";
// Styled components mapping directly to the CSS classes

const JourneyContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	background-color: transparent;
	padding: 0 2rem
`;

const TimelineWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	position: relative;
	margin-top: 3rem;
	padding-bottom: 3rem;
`;

const DottedLine = styled.div`
	position: absolute;
	top: 0.25rem;
	left: 0.25rem;
	width: calc(100% - 1rem);
	border-top: 1px dashed #000;
	z-index: 1;
`;

const MilestoneContainer = styled.div`
	position: relative;
`;

const MilestoneMarker = styled.div`
	position: absolute;
	top: -2.5rem;
	left: 50%;
	transform: translateX(-50%);
	width: max-content;
`;

const MarkerLine = styled.p`
	font-size: 0.8rem;
	color: #000;
	margin: 0;
	text-align: center;
	font-weight: 400;
	white-space: normal;
	word-break: break-word;
	overflow-wrap: anywhere;
	max-width: 5.6rem;
`;

const MilestoneDot = styled.div<any>`
	width: 0.5rem;
	height: 0.5rem;
	border-radius: 9999px;
	position: relative;
	z-index: 10;
	background-color: #000;
`;

const TextWrapper = styled.div`
	position: absolute;
	top: 1.25rem;
	left: 50%;
	transform: translateX(-50%);
	width: max-content;
	background-color: transparent;
	padding: 0 0.25rem;
	z-index: 11;
	text-align: center;
`;

const MilestoneTitle = styled.p`
	font-size: 1.3rem;
	font-weight: 600;
	color:#000;
	margin: 0;
	letter-spacing: 0.01rem;
	word-spacing: 0.01rem;
`;

const MilestoneSubtitle = styled.p`
	margin-top: 0.5rem;
	font-size: 0.75rem;
	color:#000;
	margin: 0;
	letter-spacing: 0.05rem;
`;

type MilestoneData = {
	marker: string;
	title: string;
	subtitle?: string;
};

type JourneyProps = {
	milestones?: MilestoneData[];
};

// The main React component
const JourneyComponent = (props: JourneyProps) => {
	const { milestones = [
		{ marker: "Your first dish starts in", title: "1 Min", subtitle: "" },
		{ marker: "And last dish would be out in", title: "20 Mins", subtitle: "" },
	] } = props;
	return (
		<JourneyContainer>
			<TimelineWrapper>
				<DottedLine />

				{milestones.map((m, idx) => (
					<MilestoneContainer key={idx}>
						<MilestoneMarker>
							<MarkerLine>{m.marker}</MarkerLine>
						</MilestoneMarker>
						<MilestoneDot />
						<TextWrapper>
							<MilestoneTitle>{m.title}</MilestoneTitle>
							{m.subtitle ? <MilestoneSubtitle>{m.subtitle}</MilestoneSubtitle> : null}
						</TextWrapper>
					</MilestoneContainer>
				))}
			</TimelineWrapper>
		</JourneyContainer>
	);
};

export default JourneyComponent;
